<template>
  <el-dialog
      :visible.sync="visible"
      :append-to-body="true">
    <div>
      <pre v-html="formatedMetadata">
      </pre>
    </div>
    <span
        slot="footer"
        class="dialog-footer">
      <el-button>Close</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "MetadataModal",
  props: {
    metadata: {
      type: [String, null],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    formatedMetadata() {
      let metadata = this.metadata;

      if (metadata) {
        metadata = JSON.stringify(JSON.parse(metadata), undefined, 4);
        metadata = this.syntaxHighlight(metadata);
      }

      return metadata;
    },
  },
  methods: {
    async openModal() {
      this.visible = true;
    },
    syntaxHighlight(json) {
      json = json
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
      return json.replace(
        /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
        (match) => {
          var cls = "number";
          if (/^"/.test(match)) {
            if (/:$/.test(match)) {
              cls = "key";
            } else {
              cls = "string";
            }
          } else if (/true|false/.test(match)) {
            cls = "boolean";
          } else if (/null/.test(match)) {
            cls = "null";
          }
          return '<span class="' + cls + '">' + match + "</span>";
        }
      );
    },
  },
};
</script>

<style lang="scss">
pre {
  outline: 1px solid #ccc;
  padding: 5px;
  margin: 5px;
}
.string {
  color: green;
}
.number {
  color: darkorange;
}
.boolean {
  color: blue;
}
.null {
  color: magenta;
}
.key {
  color: red;
}
</style>
